import '@/sass/base/base.scss';

import 'regenerator-runtime/runtime.js';
import 'isomorphic-unfetch';
import '@/components/commons/ssr/ssr-window.js';
import { Style } from '@article/pixel'; // eslint-disable-line no-unused-vars
import 'lazysizes';

import Vue from 'vue';
import Vuex from 'vuex';
import VueMeta from 'vue-meta';
import { sync } from 'vuex-router-sync';
import Cookies from 'cookie-universal';

import './installCompositionApi.js';

// eslint-disable-next-line import/extensions
import FeatureFlag from '@/components/commons/FeatureFlag.js';

import Tracking from '@/components/commons/Tracking.js';
// import NetworkApp from '@/components/network/Network.vue';
import { createRouter } from '@/router';
import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';
import App from './App.vue';

const s = document.createElement('script');
if (window.isServer || 'noModule' in s) {
  init();
} else {
  import(/* webpackChunkName: "polyfill-legacy" */ '@/components/commons/polyfills.legacy').then(() => {
    init();
  });
}

function init() {
  Tracking.init();

  FeatureFlag.initFeatures();

  Cookies().remove('orderID');

  window.addEventListener('load', () => {
    // Reset identity when matching the target user id
    const { userId } = Tracking.getHeapAnalyticsProperties();
    if (userId === '4139598149085179') {
      Tracking.resetHeapIdentity();
    }

    if(!window.isServer && process.env.STOREFRONT) {
      Tracking.loadGoogleAnalytics();
      Tracking.loadGoogleTagManager();
    }
  });

  UserService.getUser();
}

if (!window.article) {
  window.article = {
    data: {
      geo: {},
    },
  };
}

Tracking.exposeGeoData();
window.Cookies = window.Cookies || Cookies();
window.Style = Style;

Vue.use(Vuex);

// TODO: we need a proper way to use VueMeta with legacy bundle
if (process.env.STOREFRONT) {
  Vue.use(VueMeta, {
    ssrAppId: 1,
  });
}

Vue.config.productionTip = false;
if (process.env.DEBUG || !process.env.CONFIG_SENTRY_RELEASE) {
  Vue.config.performance = true;
}

function createStore() {
  return new Vuex.Store();
}

// eslint-disable-next-line import/prefer-default-export
export function createApp(context) {
  const router = createRouter();
  const store = createStore();

  const { cookies } = context;
  if (cookies) {
    // Override / use client cookies on server
    Object.keys(cookies).forEach((cookieKey) => {
      Cookies().set(cookieKey, cookies[cookieKey]);
    });
  }

  UserService.getUser();
  LocationService.getGeoLocation();
  LocationService.getZipLocation();

  if (!process.env.STOREFRONT) {
    sync(store, router);
  }

  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  });

  return { app, router, store };
  // window.networkApp = new Vue({
  //   el: '#network-container',
  //   render: (h) => h(NetworkApp),
  // });
}
